import Table from "../../../components/table/table";
import { TbDotsVertical } from "react-icons/tb";
import { IoEyeOutline } from "react-icons/io5";
import EditIcon from "../../../icons/editIcon";
import StarIcon from "../../../icons/starIcon";
import DeleteIcon from "../../../icons/deleteIcon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../components/dropDownMenu/dropdown-menu";
import { useNavigate } from "react-router-dom";
const EmployeesTable = ({ t, setSelected, setOpenEdit, setOpenDelete }) => {
  const navigate = useNavigate();
  const handleClick = (m, setState) => {
    setState(true);
    setSelected(m);
  };
  const employees = [
    {
      id: 1,
      name: "خالد علي",
      email: "ahmed@club.com",
      job: "مدرب لياقة",
      status: "نشط",
      hireDate: "12/6/1443 هـ",
      salary: "5000 JD",
    },
    {
      id: 2,
      name: "سارة عبدالله",
      email: "ahmed@club.com",
      job: "المبيعات",
      status: "اجازة",
      hireDate: "12/6/1443 هـ",
      salary: "5000 JD",
    },
    {
      id: 3,
      name: "هشام المدير العلي",
      email: "ahmed@club.com",
      job: "المالية",
      status: "موقوف",
      hireDate: "12/6/1443 هـ",
      salary: "5000 JD",
    },
    {
      id: 4,
      name: "نورة السالم",
      email: "ahmed@club.com",
      job: "الموارد البشرية",
      status: "نشط",
      hireDate: "12/6/1443 هـ",
      salary: "5000 JD",
    },
    {
      id: 5,
      name: "عبدالله الزهراني",
      email: "ahmed@club.com",
      job: "التسويق",
      status: "نشط",
      hireDate: "12/6/1443 هـ",
      salary: "5000 JD",
    },
  ];

  const tableHead = [
    {
      header: "id",
      accessorKey: "id",
    },
    {
      header: t("name"),
      accessorKey: "name",
    },
    {
      header: t("email"),
      accessorKey: "email",
    },
    {
      header: t("job"),
      accessorKey: "job",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },
    {
      header: t("employmentDate"),
      accessorKey: "employmentDate",
    },
    {
      header: t("salary"),
      accessorKey: "salary",
    },
    {
      header: t("actions"),
      accessorKey: "actions",
    },
  ];
  const tableData = employees.map((m, i) => {
    const statusColor =
      m.status === "نشط" ? "#E6F4EF" : m.status === "اجازة" ? "#FFE6E6" : "#FFEBCA";
    const statusTextColor =
      m.status === "نشط" ? "#11A849" : m.status === "اجازة" ? "#C42E27" : "#F59E0B";
    const status = (
      <span
        style={{ backgroundColor: statusColor, color: statusTextColor }}
        className="block w-full px-2 py-1 rounded-lg"
      >
        {m.status}
      </span>
    );
    const actions = (
      <div className="relative mx-auto w-fit">
        <DropdownMenu>
          <DropdownMenuTrigger>
            <TbDotsVertical />
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem>
              <button
                onClick={() => navigate(`/employees/${m.name}`)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("showDetails")}
                <IoEyeOutline size={24} />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenEdit)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("editInfo")}
                <EditIcon />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => {}}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("editSalary/bonus")}
                <StarIcon />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenDelete)}
                className="flex items-center gap-2 justify-end w-full text-[#FF5151] px-4 py-2 text-right hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("deleteEmployee")}
                <DeleteIcon />
              </button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
    return {
      id: m.id,
      name: m.name,
      email: m.email,
      job: m.job,
      status,
      employmentDate: m.hireDate,
      salary: m.salary,
      actions,
    };
  });
  return <Table TableData={tableData} TableHead={tableHead} />;
};

export default EmployeesTable;
